import {
    Device,
} from '@michel.freiha/ng-sdk';


export class Enroll {
    public static readonly type: string = '[Encryption] Enroll device';
    constructor(public payload: { device: Device }) { }
}
